import Layout2 from '@/layout/Layout2'

export default [{
  path: '/departments',
  component: Layout2,
  meta: { requiresAuth: true },
  children: [{
    path: '',
    component: () => import('@/components/departments/Departments')
  }, {
    path: 'create',
    component: () => import('@/components/departments/CreateDepartment')
  }, {
    path: 'edit/:id',
    component: () => import('@/components/departments/EditDepartment'),
    props: true
  }]
}]
